import React, { useCallback } from 'react';
import { K_INFO, K_VALUE } from '../../../../providers/ConfigsDataContextProvider';
import './InsightItem.css';

// Insight NewItem

const InsightItem = ({folder, folderPath, keyName, rejectMe, acceptMe}) => {
  console.log('[InsightItem] [keyName: %s]', keyName);
  
  // Same Item only it has the flag:
  //  folder[keyName][K_INFO].insight.newItem  

  const value   = folder[keyName][K_VALUE];
  const note    = folder[keyName][K_INFO].insight.note; 
  const reason  = folder[keyName][K_INFO].insight?.reason;

  const rejectInsight = useCallback(() => {
    console.log('REJECT Insight');
    rejectMe({
      basePath: folderPath,
      key: keyName
    })
  }, [rejectMe, folderPath, keyName]);

  return (
    <div className='insightItem'>
      <div className='insightItemLine'>
        <div className='insightItemCore'>
          <div className='insightKey' title={note}>
            {keyName}
          </div>
          <div className='insightValue'>
            {value} 
          </div>
          <div className='insightReason'>
            {reason}
          </div>
        </div>
      </div>

      <div className='insightCtrl'>
        <button className='insightReject' onClick={rejectInsight}>
          Reject
        </button>
        <button className='insightAccept' onClick={acceptMe}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default InsightItem;